import { ServiceFactory } from "../ServiceFactory";

// Export the abstraction, not the implementation
export const storeNotificationsService =
  ServiceFactory.getStoreNotificationsService();

// Export implementations and types for consumers
export type { IStoreNotificationsService } from "./IStoreNotificationsService";
export { StoreNotificationsService } from "./StoreNotificationsService";
